import { render, staticRenderFns } from "./testingPaper.vue?vue&type=template&id=cd7d2362&scoped=true"
import script from "./testingPaper.vue?vue&type=script&lang=js"
export * from "./testingPaper.vue?vue&type=script&lang=js"
import style0 from "./testingPaper.vue?vue&type=style&index=0&id=cd7d2362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7d2362",
  null
  
)

export default component.exports